module.exports = __webpack_public_path__ + "static/img/solution_img2.41b99070.png";